
import { NgModule } from '@angular/core';

import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzModalModule} from 'ng-zorro-antd/modal';
import { NzSelectModule} from 'ng-zorro-antd/select';
import { NzTableModule} from 'ng-zorro-antd/table';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzSpinModule } from 'ng-zorro-antd/spin'; //Added by shraddha
@NgModule({
  exports: [
    NzButtonModule,NzFormModule, NzTableModule,NzTabsModule,NzUploadModule,NzSelectModule,
     NzIconModule,NzModalModule,NzButtonModule,NzRadioModule,NzSwitchModule,NzSpinModule
  ]
})

export class NgZorroAntdModuleModule { }
